module.exports = __webpack_public_path__ + "static/media/card3.a8ff6b56.png";